"use client";

import { useActionState } from "react";
import { login } from "@/lib/actions";
import { SubmitButton } from "./SubmitButton";

export function LoginForm() {
  const [state, action] = useActionState(login, undefined);

  return (
    <form action={action} className="space-y-4">
      <div>
        <label className="label" htmlFor="username">Usuario</label>
        <input id="username" name="username" defaultValue={state?.values?.username} autoComplete="username" className="input" required autoFocus />
      </div>
      <div>
        <label className="label" htmlFor="password">Contraseña</label>
        <input id="password" name="password" type="password" autoComplete="current-password" className="input" required />
      </div>
      {state?.error && <p className="rounded-lg bg-rose-50 p-3 text-sm text-rose-700">{state.error}</p>}
      <SubmitButton className="btn-primary w-full py-2.5" pendingText="Entrando…">Entrar</SubmitButton>
    </form>
  );
}
